import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Observable} from 'rxjs';
import {CriteriaResponse} from 'src/app/models/criteria.model';
import {AuthService} from "./auth.service";

@Injectable({
    providedIn: 'root',
})
export class CriteriaService {

    constructor(private readonly http: HttpClient,
                private readonly authService: AuthService) {
    }
    private getHeaders(): HttpHeaders {
        const token = this.authService.getAccessToken() || '';
        const host = window.location.hostname.toLowerCase();
        const domainExt = host.match(/\.(com|net)/)?.[0] || '';
        const domainStr = domainExt === '.com' ? 'com' : 'net';

        return new HttpHeaders()
            .set('Authorization', `${token}`)
            .set('domain', domainStr);
    }
    postCriteriaSelection(dealerCode: string): Observable<CriteriaResponse> {
        const url = '/criteria/selection';

        const body = {dealerCode};

        return this.http.post<CriteriaResponse>(url, body, { headers: this.getHeaders() });
    }
}
